import * as React from 'react';
import {
    TriggerWrapper,
    RotateIconTrigger,
    Text,
    Flex,
    Button,
    AIStarIcon
} from '@priority-software/priority-style-react';
import List from '../../../components/Common/List';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {setDefaultSearch, reorderSearches, deleteSearch} from '../actions/searchesList';
import {observer} from 'mobx-react';
import {returnFocus} from '../../../_shared/GWTBridge/invoke/genPage';
import {Component, Fragment} from 'react';
import {withHover} from '../../../components/Common/HOC/withHover';
import cx from 'classnames';
import {
    Icon,
    PriorityIcon,
    Dropdown,
    withDropdownContext
} from '@priority-software/priority-style-react';
import {Draggable} from '@priority-software/priority-style-react';
import {Search as SearchStore} from '../stores/Search';
import {showConfirmMessage} from '../../../_shared/Messages/actions/MessageActions';
import messageText from '../../../_shared/Messages/texts';
import {messagesIds} from '../../../_shared/Messages/consts';
import {MenuItem} from '../../FormHeader/components/Menus/MenuItem';
import {hoverBtns, DataTestIds} from '../consts/enums';
import {ModernTooltip} from '../../../components/Common/Tooltip/ModernTooltip';
import {renderGenerator} from '../renderGenerator';
import {IndexedSearch} from '../../../services/indexDB/indexeddbServiceSearches';
import AIStarWithBorder from '../../../images/AIStarWithBorder.svg';
import {createDataTestId} from '../../../utils/dataTestId';

const HoverButton = ({onClick, title, button, className = ''}) => {
    switch (button) {
        case hoverBtns.Default:
            return (
                <div className={cx('label ignore-clickoutside', className)} onClick={onClick}>
                    <ModernTooltip position="top" tooltip={<Text skin="paragraph-2">{title}</Text>}>
                        <Icon
                            onClick={onClick}
                            icon={
                                getLocalizedText(texts.unsetDefault) === title
                                    ? PriorityIcon.starFilled
                                    : PriorityIcon.starEmpty
                            }
                            iconColor={
                                getLocalizedText(texts.unsetDefault) === title
                                    ? 'primary-500'
                                    : undefined
                            }
                        />
                    </ModernTooltip>
                </div>
            );

        case hoverBtns.Save:
            return (
                <Button
                    skin="text"
                    componentClasses={cx('label hover-button ignore-clickoutside', className)}
                    onClick={onClick}
                >
                    {title}
                </Button>
            );

        case hoverBtns.Delete:
            return (
                <div className={cx('label', className)} style={{display: 'flex'}}>
                    <Icon skin="primary" icon={PriorityIcon.delete} onClick={onClick} />
                </div>
            );
        case hoverBtns.Edit:
            return (
                <div className={cx('label', className)} style={{display: 'flex'}}>
                    <Icon skin="primary" icon={PriorityIcon.editFill} onClick={onClick} />
                </div>
            );
        default:
            return null;
    }
};

class HoverButtons extends Component<{item; hoverBtnsArr: Array<any>}, null> {
    constructor(props) {
        super(props);
        this.executeAction = this.executeAction.bind(this);
    }

    executeAction(e, button) {
        const {item} = this.props;
        e.stopPropagation();
        switch (button) {
            case hoverBtns.Default:
                setDefaultSearch(item);
                break;
            case hoverBtns.Edit:
                renderGenerator('searchesGenerator', this.props);
                break;
            case hoverBtns.Delete:
                showConfirmMessage({
                    id: messagesIds.searches.deleteSavedItem,
                    title: messageText.deleteSearch,
                    confirmButtonText: messageText.yesExitSearch,
                    cancleButtonText: messageText.noChangedMyMind,
                    isRemovable: false,
                    defaultButton: 0,
                    onConfirm: () => deleteSearch(item)
                });
                break;
            case hoverBtns.Save:
                renderGenerator('searchesGenerator', this.props);
                break;
            default:
                break;
        }
    }

    renderTitle(item, button) {
        let title;
        switch (button) {
            case hoverBtns.Default:
                title = item.isDefault
                    ? getLocalizedText(texts.unsetDefault)
                    : getLocalizedText(texts.setDefault);
                break;
            case hoverBtns.Edit:
                title = getLocalizedText(texts.edit);
                break;
            case hoverBtns.Delete:
                title = getLocalizedText(texts.del);
                break;
            case hoverBtns.Save:
                title = getLocalizedText(texts.save);
                break;
            default:
                break;
        }
        return title;
    }

    render() {
        const {item, hoverBtnsArr} = this.props;
        return (
            <Flex componentClasses="actions-btn-container">
                {hoverBtnsArr.map((btn, idx) => {
                    return (
                        <Fragment key={idx}>
                            <HoverButton
                                className="button-padding"
                                key={idx}
                                onClick={e => this.executeAction(e, btn)}
                                title={this.renderTitle(item, btn)}
                                button={btn}
                            />
                        </Fragment>
                    );
                })}
            </Flex>
        );
    }
}

const Search = observer(
    ({item, hoverBtnsArr, isLastIndex, onSelect, index, selectedSearch, ...dragProps}) => {
        return (
            <Draggable
                {...(dragProps as {dragHandleProps; draggableProps; innerRef; isDragged; inDrag})}
                componentClasses="dropdown-drag-item"
                iconPosition="center"
            >
                <Dropdown.Item
                    index={index}
                    onClick={() => onSelect(item)}
                    selectedIndex={selectedSearch}
                    divider={!isLastIndex}
                    componentClasses="search-dropdown-item"
                >
                    <MenuItem
                        className="menu-item"
                        label={
                            item.isDefault && (
                                <Icon icon={PriorityIcon.starFilled} iconColor={'primary-500'} />
                            )
                        }
                        hoverComp={<HoverButtons item={item} hoverBtnsArr={hoverBtnsArr} />}
                        title={item.name || item.title}
                        shortkey={item.shortKey}
                    />
                </Dropdown.Item>
            </Draggable>
        );
    }
);
const PreviousSearch = observer(({item, isLastIndex, hoverBtnsArr, onSelect, index}) => {
    return (
        <Dropdown.Item
            componentClasses="previous-search-item"
            index={index}
            onClick={() => onSelect(item)}
            divider={!isLastIndex}
            className
        >
            <MenuItem hoverComp={hoverBtnsArr} title={item.name || item.title} />
        </Dropdown.Item>
    );
});

type SearchTriggerCompProps = {
    selectedSearch: any;
    hoverCompAction: () => void;
    dropdownContext: any;
    isHovering?: boolean;
    displayFiltersCounter?: boolean;
    hasRecommendedSearch?: boolean;
};

const SearchTriggerComp = observer(
    ({
        selectedSearch,
        hoverCompAction,
        dropdownContext,
        isHovering = false,
        displayFiltersCounter = false,
        hasRecommendedSearch = false
    }: SearchTriggerCompProps) => {
        const {open, toggle} = dropdownContext;
        const [isShowTooltip, setIsShowTooltip] = React.useState(false);

        const handleToggleShow = React.useCallback(
            (flag: boolean) => {
                if (open) {
                    setIsShowTooltip(false);
                } else {
                    setIsShowTooltip(flag);
                }
            },
            [open]
        );
        const titleText = selectedSearch
            ? selectedSearch.name
            : getLocalizedText(texts.savedSearches);

        return (
            <div className={`dropdown-wrapper ${open && 'active'}`}>
                <TriggerWrapper
                    dropdownContext={dropdownContext}
                    className="search-trigger-wrapper"
                >
                    <ModernTooltip
                        tooltip={titleText}
                        maxWidth={360}
                        position="bottom"
                        show={isShowTooltip}
                        toggleShow={handleToggleShow}
                    >
                        <div
                            className="flex-container"
                            onClick={toggle}
                            {...createDataTestId(DataTestIds.searchesDropdownTrigger)}
                        >
                            {hasRecommendedSearch && (
                                <img
                                    src={AIStarWithBorder}
                                    alt="AI Stars Icon"
                                    className="recommended-search-icon"
                                    {...createDataTestId(DataTestIds.recommendedSearchIcon)}
                                />
                            )}
                            <Icon
                                componentClasses="search-filter-icon"
                                iconColor={open ? 'primary-500' : 'primary-700'}
                                icon={PriorityIcon.filter}
                                counterValue={
                                    displayFiltersCounter &&
                                    selectedSearch &&
                                    selectedSearch.filtersCounter
                                }
                            />
                            <div className="text-button">
                                <Text skin="paragraph-2" componentClasses={'saved-search-title'}>
                                    {selectedSearch ? selectedSearch.name : titleText}
                                </Text>
                            </div>
                            <RotateIconTrigger
                                icon={PriorityIcon.arrowBottom}
                                dropdownContext={dropdownContext}
                                rotate="180deg"
                                componentClasses={cx('dropdown-icon', {['active-color']: open})}
                            />
                        </div>
                    </ModernTooltip>
                </TriggerWrapper>
                {hoverCompAction &&
                    selectedSearch &&
                    !selectedSearch.isNew &&
                    !selectedSearch.isPrevious && (
                        <Icon
                            invisible={!isHovering || open}
                            skin="primary"
                            icon={PriorityIcon.editFill}
                            onClick={hoverCompAction}
                        />
                    )}
            </div>
        );
    }
);

interface DropdownSearchesListProps {
    searchesStore: any;
    selectedSearch: SearchStore;
    hoverBtnsArr: hoverBtns[];
    onSelect(search: SearchStore);
    numOfItemsToDisaplay: any;
    onPreviousSelect?: (item) => void;
    hoverCompAction?(): void;
    onButtonClick?(): void;
    isButtonDisabled?: boolean;
}

const DropdownSearchesList = observer((props: DropdownSearchesListProps) => {
    const {searchesStore, hoverBtnsArr, onSelect, numOfItemsToDisaplay} = props;
    const {savedSearchesList} = searchesStore;
    if (!savedSearchesList || savedSearchesList.length === 0) {
        return null;
    }
    return (
        <div>
            <Dropdown.Header
                title={getLocalizedText(texts.savedSearches)}
                componentClasses="dropdown-menu-header"
            />
            <List
                data={savedSearchesList}
                autoHeight
                autoHeightMax={55 * numOfItemsToDisaplay}
                renderItem={({item, index, isLastIndex, ...props}) => (
                    <Search
                        isLastIndex={isLastIndex}
                        item={item}
                        index={index}
                        hoverBtnsArr={hoverBtnsArr}
                        onSelect={onSelect}
                        {...props}
                    />
                )}
                draggable={true}
                handleDNDFinish={(list, destinationIdx) =>
                    reorderSearches(searchesStore, list, destinationIdx)
                }
            />
        </div>
    );
});
interface DropdownNewSearchProps {
    searchesStore: any;
    onSelect(search: SearchStore);
}

const DropdownNewSearch = observer((props: DropdownNewSearchProps) => {
    const {searchesStore} = props;
    const {formSelected} = searchesStore;

    if (!formSelected || !formSelected.isNew) return null;

    return (
        <Dropdown.Item index={0} componentClasses="previous-search-item">
            <MenuItem
                label={<HoverButtons item={formSelected} hoverBtnsArr={[hoverBtns.Save]} />}
                title={getLocalizedText(texts.newSearch)}
            />
        </Dropdown.Item>
    );
});

interface DropdownPreviousListProps {
    searchesStore: any;
    selectedSearch: SearchStore;
    hoverBtnsArr: hoverBtns[];
    onSelect(search: SearchStore);
    numOfItemsToDisaplay: any;
    onPreviousSelect?: (item) => void;
    hoverCompAction?(): void;
    onButtonClick?(): void;
    isButtonDisabled?: boolean;
    isShowPrevious?: boolean;
}

const DropdownPreviousList = observer((props: DropdownPreviousListProps) => {
    const {searchesStore, onPreviousSelect, isShowPrevious} = props;
    const {savedSearchesList, getPreviousList} = searchesStore;
    const PreviousList = getPreviousList;

    if (!PreviousList || PreviousList.length === 0 || !isShowPrevious) {
        return null;
    }
    return (
        <div>
            <Dropdown.Header
                title={getLocalizedText(texts.previousSearches)}
                componentClasses="dropdown-menu-header"
            />
            <List
                data={PreviousList}
                autoHeight
                autoHeightMax={55 * 3}
                renderItem={({item, index, isLastIndex, ...props}) => (
                    <PreviousSearch
                        item={item}
                        isLastIndex={isLastIndex}
                        index={index + savedSearchesList.length}
                        onSelect={onPreviousSelect}
                        {...props}
                    />
                )}
            />
        </div>
    );
});

const SearchTrigger = withHover(withDropdownContext(SearchTriggerComp));

interface SearchesDropdownProps {
    searchesStore: any;
    selectedSearch: SearchStore;
    hoverBtnsArr: hoverBtns[];
    openingSide: 'rightSide' | 'leftSide';
    onSelect(search: SearchStore): void;
    onPreviousSelect?: (item) => void;
    hoverCompAction?(): void;
    onButtonClick?(): void;
    isButtonDisabled?: boolean;
    isShowPrevious?: boolean;
    displayFiltersCounter?: boolean;
    recommendedSearch?: IndexedSearch;
}

export const SearchesDropdown = observer((props: SearchesDropdownProps) => {
    const {
        searchesStore,
        selectedSearch,
        openingSide,
        hoverCompAction,
        onButtonClick,
        isButtonDisabled,
        displayFiltersCounter,
        recommendedSearch
    } = props;
    const numOfItemsToDisaplay = 5;
    const {savedSearchesList, getPreviousList} = searchesStore;
    const PreviousList = getPreviousList;
    return savedSearchesList || PreviousList ? (
        <Dropdown
            trigger={
                <SearchTrigger
                    hoverCompAction={hoverCompAction}
                    selectedSearch={selectedSearch}
                    displayFiltersCounter={displayFiltersCounter}
                    hasRecommendedSearch={!!recommendedSearch}
                />
            }
            onClose={returnFocus}
            openingSide={openingSide}
            className="queries-list"
        >
            {
                <Dropdown.Content width={480} zIndex={1002}>
                    <DropdownNewSearch {...props} />
                    <DropdownSearchesList numOfItemsToDisaplay={numOfItemsToDisaplay} {...props} />
                    <DropdownPreviousList
                        numOfItemsToDisaplay={3} //DOTO need to be numOfItemsToDisaplay
                        {...props}
                    />
                    <div
                        className={cx('new-search-footer', {
                            ['disabled']: isButtonDisabled,
                            ['with-suggestion']: !!recommendedSearch
                        })}
                        onClick={!isButtonDisabled && onButtonClick && onButtonClick}
                    >
                        <Icon
                            icon={PriorityIcon.newAdd}
                            disabled={isButtonDisabled}
                            componentClasses="searches-dropdown-add-icon"
                        />
                        <Flex direction="column" alignItems="flex-start">
                            <Text skin="paragraph-2">
                                {getLocalizedText(texts.createNewSearch)}
                            </Text>
                            {!!recommendedSearch && (
                                <Flex
                                    {...createDataTestId(
                                        DataTestIds.recommendationIndication,
                                        true
                                    )}
                                >
                                    <Text skin="breadcrumb">
                                        {getLocalizedText(texts.recommendationForYou)}
                                    </Text>
                                    <AIStarIcon />
                                </Flex>
                            )}
                        </Flex>
                    </div>
                </Dropdown.Content>
            }
        </Dropdown>
    ) : null;
});
